export default __webpack_public_path__ + "static/media/ban-desktop-image-8.6238b2f7.jpg";